// extracted by mini-css-extract-plugin
module.exports = {"imageContainer":"_1dOHDTziWXk2oxfGMmu0Mv","tabContent":"_1IwjMPAQkgSAYp_NIdhlN7","reviewText":"_1Wqe-dS5aEUuY5O0JxPfxY"};